module.exports = __webpack_public_path__ + "img/1dfff95.jpg";